import React from "react";
import {Link} from "react-router-dom";
import {FarmyColumnSet, FarmyColumn} from "../../layouts/components/FarmyColumns";
import {Title3} from "../../layouts/components/Titles";
import {t} from "../../../shared-services/translate";

const ProductInfo = (props) => {
  const {product, className = "", style} = props;
  const {additionalInfo} = product;

  return <div className={`product-info ${className}`} style={style}>
    <Title3 className="text-strong margin-bottom-10">
      {t("product_page.information")}
    </Title3>

    {additionalInfo && additionalInfo.map(item => <div className="additional-info" key={item?.value}>
      <FarmyColumnSet className="justify-content-space-between margin-bottom-20">
        <FarmyColumn width="40%" className="text-color-dimmed text-strong">{item.label}</FarmyColumn>

        {item?.url
          ? <Link to={item?.url} target="_blank">
            <FarmyColumn className="text-strong text-align-right link-style">{item.value}</FarmyColumn>
          </Link>
          : <FarmyColumn className="text-strong text-align-right">{item.value}</FarmyColumn>
        }
      </FarmyColumnSet>

    </div>)}
  </div>;
};

export default ProductInfo;
